import { useActiveTheme } from '@care/react-component-lib';
import { Icon24Camp } from '@care/react-embrace-icons';
import { FilterPill } from '@care/provider-react-components';
import { Icon24InfoCamp } from '@care/react-icons';

import { FilterFieldNames } from '@/constants';

export interface CampsFilterProps {
  defaultValue?: boolean;
  onChange: (v: boolean) => void;
}

const { camp } = FilterFieldNames;
export const CampsFilter = ({ defaultValue, onChange }: CampsFilterProps) => {
  const { isEmbraceTheme } = useActiveTheme();

  const CampIcon = isEmbraceTheme ? Icon24Camp : Icon24InfoCamp;

  return (
    <FilterPill
      name={camp}
      label="Camps"
      defaultValue={defaultValue}
      icon={<CampIcon />}
      iconPosition="left"
      modalProps={{ hideInModal: false, label: 'Booking type' }}
      onChange={onChange}
    />
  );
};
